import { gql } from '@apollo/client';

export const GetEnterpriseClients = gql`
  query GetEnterpriseClients($input: ClientSearchInput!) {
  getEnterpriseClients(input: $input) {
    totalCount
    data {
      id
      name
      entityType
      taxId
      status
      primaryColor
      secondaryColor
      accentColor
      url
      domain
      email
      products
      modifiedBy
      modifiedOn
      createdBy
      createdOn
      logo {
        id
        fileName
        bucket
        presignedURL
        publicURL
      }
      addresses {
        id
        addressLine
        addressLine2
        addressType
        city
        state
        zip4
        zip5
        country
        isPrimary
      }
    }
  }
}
`;

export const GetOverallEnterpriseClientStats = gql`
  query GetOverallEnterpriseClientStats {
    getOverallEnterpriseClientStats {
      total
      active
    }
  }
`;

export const GetEnterpriseUser = gql`
  query GetEnterpriseUser {
    getEnterpriseUser {
      id
      clientId
      firstName
      lastName
      role
      type
      taxId
      status
      inviteStatus
      email
      phones {
        phoneType
        phoneNumber
        phoneExt
        isPrimary
      }
      lastSeen
      emailNotification
      textNotification
      modifiedBy
      modifiedOn
      createdBy
      createdOn
    }
  }
`;

export const GetEnterpriseEmployeesByEnterpriseIdV2 = gql`
  query GetEmployeesByClientId(
    $input: EmployeeSearchInput!
  ) {
    # getEmployeesByClientId(input: $input, clientId: $clientId) {
    getEmployees(input: $input) {
      totalCount
      employees {
        id
        externalEmployeeId
        email
        firstName
        lastName
        phones {
          phoneType
          phoneNumber
        }
        appStatus
        status
        # addresses {
        #   id
        #   # addressLine
        #   # addressLine2
        #   addressType
        #   city
        #   state
        #   zip4
        #   zip5
        #   country
        #   isPrimary
        # }
        ssn
        appInvitedBy
        modifiedBy
        modifiedOn
        createdBy
        createdOn
      }
    }
    # getEmployeeStatsByClientId(clientId: $clientId) {
    getEmployeeStats {
      total
      registered
      active
      invited
    }
  }
`;

export const GetEnterpriseClientByIdV2 = gql`
  query GetClientUsersByClientId($clientId: ID!) {
    getClientUsersByClientId(clientId: $clientId) {
      id
      clientId
      firstName
      lastName
      role
      type
      taxId
      status
      inviteStatus
      email
      phones {
        phoneType
        phoneNumber
        phoneExt
        isPrimary
      }
      lastSeen
      emailNotification
      textNotification
      modifiedBy
      modifiedOn
      createdBy
      createdOn
    }
    getEmployeeStatsByClientId(clientId: $clientId) {
      total
      registered
      active
      invited
    }
  }
`;

export const GetEnterpriseByIDV2 = gql`
  query GetEnterpriseById($clientId: ID!) {
    getEnterpriseUser {
      id
      clientId
      firstName
      lastName
      role
      type
      taxId
      status
      inviteStatus
      email
      phones {
        phoneType
        phoneNumber
        phoneExt
        isPrimary
      }
      lastSeen
      emailNotification
      textNotification
      modifiedBy
      modifiedOn
      createdBy
      createdOn
    }
    # getEmployeeStats {
    getEmployeeStatsByClientId(clientId: $clientId) {
      total
      registered
      active
      invited
    }
    getClientUsersByClientId(clientId: $clientId) {
      id
      clientId
      firstName
      lastName
      role
      type
      taxId
      status
      inviteStatus
      email
      phones {
        phoneType
        phoneNumber
        phoneExt
        isPrimary
      }
      lastSeen
      emailNotification
      textNotification
      modifiedBy
      modifiedOn
      createdBy
      createdOn
    }
  }
`;


export const GetUploadEnterpriseEmployeeMappingsV2 = gql`
  query GetUploadEnterpriseEmployeeMappings($fileMetadataId: ID!) {
    getEmployeeMapping(fileMetadataId: $fileMetadataId) {
      csvHeaders
      mapping {
        # address
        email
        employeeId
        firstName
        lastName
        email
        phoneNumber
        # ssn
      }
    }
  }
`;

export const GetUploadedHistoryByEnterpriseIdV2 = gql`
query GetEmployeeUploadHistory($input: EmployeeUploadHistorySearchInput!) {
  getEmployeeUploadHistory(input: $input) {
    totalCount
    uploadHistory {
      file {
        fileName
        id
        presignedURL
      }
      id
      status
      errorRecords {
        message
        row
      }
      createdOn
      uploadedEmployeeStats {
        total
        new
        # duplicate
        modified
        error
      }
    }
  }
}
`;

export const GetEnterpriseUsers = gql`
  query GetEnterpriseUsers {
    getEnterpriseUsers {
      id
      clientId
      firstName
      lastName
      role
      type
      taxId
      status
      inviteStatus
      email
      lastSeen
      emailNotification
      textNotification
      modifiedBy
      modifiedOn
      createdBy
      createdOn
      phones {
        phoneType
        phoneNumber
        phoneExt
        isPrimary
      }
    }
    getEmployeeStats {
      total
      registered
      active
      invited
    }
  }
`;

export const GetEnterpriseUserInviteById = gql`
  query GetEnterpriseUserInviteById($getEnterpriseUserInviteByIdId: ID!) {
    getEnterpriseUserInviteById(id: $getEnterpriseUserInviteByIdId) {
      id
      clientId
      email
      role
      firstName
      lastName
      expiration
      status
      createdBy
      createdOn
    }
  }
`;